module.exports = __webpack_public_path__ + "media/images/subject_img/CHEMISTRY-8fa3a43f0372f5a40c20a926d0d80683.jpg";